import { Container, Navbar, Nav, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-scroll';
import "./Header.css";
import logoImg from '../assets/img/portfolio-logo.png';
import { useState } from 'react';

export const Header = ({ contentData }) => {
    const [fix, setFix] = useState(false);
    function handleFixed() {
        if(window.scrollY > 10) {
            setFix(true);
        } else {
            setFix(false);
        }

    }

    window.addEventListener("scroll", handleFixed);

    return (
        <div className='header-container' id='header'>

            <Navbar expand="lg" className={fix ? "fixed bg-dark" : ""}>
                <Container>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse className='text-center' id="navbarScroll">
                        <Nav className="m-auto" >
                            <Link className='nav-link' to="header" spy={false} smooth={true} offset={0} duration={500}>Home</Link>
                            <Link className='nav-link' to="about" spy={false} smooth={true} offset={-50} duration={500}>About</Link>
                            <Link className='nav-link' to="projects" spy={false} smooth={true} offset={-50} duration={500}>Project</Link>
                            <Link className='nav-link' to="contact" spy={true} smooth={true} offset={50} duration={500}>Contact</Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <Container>
                <Row className='header-content text-center pt-5 pt-lg-0 align-items-lg-center pb-5'>
                    <Col xs={12}>
                        <div>
                            <Image className='logo' src={logoImg} />
                        </div>
                        <h1 className='esd-font header-name'>{contentData.name}</h1>
                        <p>I am an {contentData.role}. {contentData.roleDescription}.</p>
                        <hr />
                        <div>
                            {
                                contentData.socialLinks.map((link, index) => (
                                    <a className='social-icons' target='_blank' href={link.url} key={index}><i className={link.className}></i></a>
                                ))
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}